(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/store/redux.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/store/redux.js');

'use strict';

const {
  reducer
} = svs.playerLoginReact.store;
const combinedReducers = RTK.combineReducers({
  playerloginreact: reducer
});

svs.playerLoginReact.store.createStore = function () {
  let preloaded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return RTK.configureStore({
    reducer: combinedReducers,
    preloadedState: preloaded
  });
};
const store = svs.playerLoginReact.store.createStore();
const PlayerLoginReactReduxProvider = _ref => {
  let {
    children
  } = _ref;
  return React.createElement(ReactRedux.Provider, {
    store: store
  }, children);
};
svs.playerLoginReact.store.PlayerLoginReactReduxProvider = PlayerLoginReactReduxProvider;
if (svs.accountservices.check_iam.isIamIFrameEnabled) {
  svs.playerLoginReact.storeRef = store;
}

 })(window);